import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-info',
  templateUrl: './job-info.component.html',
  styleUrls: ['./job-info.component.css']
})
export class JobInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
